{
  "paymentMethodUnavailable": "Không thể dùng phương thức thanh toán này",
  "serverError": "Lỗi máy chủ, vui lòng thử lại sau.",
  "tradeRecommendation": "Gợi ý giao dịch",
  "tradeRecommendationDescription": "Không tìm thấy lệnh phù hợp với số tiền của bạn, nhưng có số tiền được đề xuất. Bạn có muốn giao dịch theo số tiền đó không?",
  "tradeWithRecommendation": "Đồng ý, giao dịch theo số tiền gợi ý",
  "listOriginalAmount": "Không, niêm yết với số tiền ban đầu",
  "selectPaymentMethod": "Vui lòng chọn phương thức thanh toán",
  "selectReceivingMethod": "Vui lòng chọn phương thức nhận tiền",
  "fastTradingUnavailable": "Giao dịch nhanh tạm thời không khả dụng, vui lòng thử lại sau.",
  "paymentAmountLimitExceeded": "Vượt quá giới hạn số tiền thanh toán",
  "securityReminder": "Lưu ý: {{token}} chỉ liên hệ qua bộ phận hỗ trợ trực tuyến, không gọi điện hay liên hệ qua Alipay hoặc WeChat.",
  "buyToken": "Mua {{token}}",
  "sellToken": "Bán {{token}}",
  "selectTradingMethod": "Chọn phương thức giao dịch",
  "paymentMethodsUnavailable": "Phương thức thanh toán tạm thời không khả dụng",
  "unavailableMethodRetry": "{{methods}} vừa không thể xử lý thanh toán này. Bạn vẫn có thể thử lại các phương thức có chấm đỏ hoặc chọn phương thức khác.",
  "unavailableMethodChooseOther": "{{methods}} vừa không thể xử lý thanh toán này. Vui lòng chọn phương thức khác.",
  "vipFastPayEligibility": "Bạn đang ở VIP {{level}}. Các phương thức {{methodType}} sau đáp ứng điều kiện giao dịch nhanh.",
  "continueStandardC2C": "Tiếp tục C2C thường",
  "methodUnavailableRetry": "{{method}} tạm thời không khả dụng, có thể thử lại",
  "unavailableRetry": "Tạm thời không khả dụng, có thể thử lại",
  "selectThisMethod": "Chọn phương thức này",
  "vipAvailability": "Phạm vi VIP áp dụng",
  "fee": "Phí",
  "expectedCredit": "Dự kiến ghi có",
  "fastPayCollectionInformation": "Thông tin nhận tiền giao dịch nhanh",
  "scanToPay": "Dùng {{method}} quét mã QR để thanh toán.",
  "payUsingInformation": "Vui lòng thanh toán theo thông tin dưới đây.",
  "receivingQrCode": "Mã QR nhận tiền {{method}}",
  "orderNumber": "Mã lệnh",
  "receivingName": "Tên người nhận",
  "receivingAccount": "Tài khoản nhận tiền",
  "amountDue": "Số tiền phải trả",
  "transactionChannel": "Kênh giao dịch",
  "paymentDeadline": "Hạn thanh toán",
  "notice": "Lưu ý",
  "payExactAmount": "Vui lòng thanh toán đúng số tiền phải trả",
  "close": "Đóng",
  "kycRequired": "Vui lòng xác minh danh tính trước",
  "kycRequiredDescription": "Hãy xác minh danh tính trước khi tiếp tục dùng phương thức giao dịch này.",
  "gotIt": "Tôi đã hiểu",
  "goToKyc": "Đi xác minh",
  "cannotStartTrade": "Không thể mở giao dịch mới",
  "buyOrderInProgress": "Bạn đang có lệnh mua đang xử lý. Hãy chờ giao dịch đó kết thúc trước khi mở giao dịch mua mới.",
  "minimumTransactionRequired": "Vui lòng nhập số lượng tối thiểu mỗi giao dịch",
  "minimumLessThanListed": "Phải nhỏ hơn tổng số lượng niêm yết",
  "insufficientBalance": "Số dư không đủ để niêm yết",
  "listedQuantityLimitExceeded": "Vượt quá giới hạn tổng số lượng niêm yết",
  "availableBalance": "Số dư khả dụng:",
  "selectedReceivingMethods": "Đã chọn {{count}} phương thức nhận tiền",
  "fastSell": "Bán nhanh",
  "fastSellSubmitted": "Đã gửi yêu cầu bán. Kết quả ghi có theo trạng thái hệ thống.",
  "fastSellFailed": "Yêu cầu bán không thành công, vui lòng thử lại hoặc dùng C2C thường.",
  "providerOrderNumber": "Mã lệnh nhà cung cấp",
  "providerFee": "Phí nhà cung cấp",
  "status": "Trạng thái",
  "remark": "Ghi chú",
  "minimumTransactionHint": "Người mua phải mua ít nhất số lượng này.",
  "fastPayDetails": "Chi tiết giao dịch nhanh",
  "orderStatus": "Trạng thái lệnh",
  "closedAt": "Thời gian đóng",
  "amountInformation": "Thông tin số tiền",
  "creditedQuantity": "Số lượng đã ghi có"
}
